import Slider from "react-slick";
import { NextArrow, PrevArrow } from "../Arrows";
import { Link } from "react-router-dom";

function Portfolio({ portfolio }) {



  const protfolio2slider = {
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        arrows: true,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        draggable: false,
        swipe: true,
        touchMove: true,
        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 }
            }
        ]
    };

  return (
    <>
      <div className="portfolio-section mb-100" data-aos="fade-up">
        <div className="container">
              <div className="section-title2 primary3 text-start">
                <span>{portfolio.main_title}</span>
                  <h2>{portfolio.highlist_title}</h2>
            </div>
         <div className="portfolio-items position-relative">
      <Slider {...protfolio2slider}>
        {portfolio.portfolio_list.map((info, index) => (
          <div key={index}>
            <div className="portfolio-wrap glass-effect">
              <div
                className="portfolio-item1 style-1  event-portfolio"
                data-wow-duration="1.5s"
                data-wow-delay="0.2s"
              >
                {info.target_url === "" ? (
                  <div className="portfolio-img">
                    <img alt="info" src={info.image} />
                  </div>
                ) : (
                  <div className="portfolio-img">
                    <Link to="/past-events">
                      <img alt="info" src={info.image} />
                    </Link>
                  </div>
                )}

                <div className="portfolio-content">
                  <h4>
                      {info.services_title}
                   </h4>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
        </div>
      </div>
    </>
  );
}

export default Portfolio;
